module.exports = __webpack_public_path__ + "img/helpvideoCover.1406baef.jpg";